import { Injectable } from '@angular/core';
import { buildConsultationData, setUndefinedClinicPrice } from '@app/shared/utils/static-helpers/consultation-helper';
import { AppState } from '@app/store';
import { checkForExistingOwner } from '@app/store/consultation/consultation.actions';
import { selectConsultation, selectConsultationRenalDetectPrediction } from '@app/store/consultation/consultation.selectors';
import { selectCurrentBigMeasurementUnit, selectVet } from '@app/store/vet';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { selectAllowanceCurrentProgram } from '../selectors/allowance-program.selectors';
import { selectAllowance } from '../selectors/allowance.selectors';
import { selectSelectedProducts, selectSelectedPackIds } from '@app/store/products/products.selectors';
import { createAllowanceConsultationVetSource } from '../actions/allowance-vetsource.actions';
import { selectShareRecommendationData } from '@app/store/share-recommendation';
import { selectIsPetInLactation } from '../selectors/allowance-params.selectors';

@Injectable()
export class AllowanceVetSourceEffects {
  /**
   * Prepare Vet Source order
   * Prepare the data for creating consultation inside consultation store
   */
  createAllowanceConsultationVetSource$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createAllowanceConsultationVetSource),
      withLatestFrom(
        this.store$.select(selectConsultation),
        this.store$.select(selectSelectedPackIds),
        this.store$.select(selectAllowance),
        this.store$.select(selectConsultationRenalDetectPrediction),
        this.store$.select(selectSelectedProducts),
        this.store$.select(selectAllowanceCurrentProgram),
        this.store$.select(selectVet),
        this.store$.select(selectShareRecommendationData),
        this.store$.select(selectCurrentBigMeasurementUnit),
        this.store$.select(selectIsPetInLactation),
      ),
      switchMap(
        ([
          { email, owner, clinic },
          consultationState,
          selectedPackIds,
          allowanceState,
          prediction,
          products,
          program,
          vet,
          shareRecoData,
          currentBigMeasurementUnit,
          isLactation,
        ]) => {
          const petInfo = allowanceState?.allowanceParams?.deprecatedPetInfo ?? shareRecoData?.petInfo;
          const tool = allowanceState?.allowanceParams?.tool ?? shareRecoData?.tool;
          const currentConsultation = allowanceState?.allowanceParams
            ? setUndefinedClinicPrice(
                buildConsultationData({
                  consultationState,
                  allowanceState,
                  selectedPackIds,
                  prediction,
                  products,
                  program,
                  vet,
                  tool,
                  currentBigMeasurementUnit,
                  isLactation,
                }),
              )
            : setUndefinedClinicPrice(shareRecoData.currentConsultation);
          return [
            checkForExistingOwner({
              email,
              owner,
              petInfo: petInfo,
              currentConsultation,
              clinic,
            }),
          ];
        },
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<AppState>,
  ) {}
}
